module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<header>\r\n  <div class="header container">\r\n    <a href="/" class="web-logo bold">\r\n      <img src="' +
((__t = (require('../../assets/images/logo1.png'))) == null ? '' : __t) +
'" alt="">\r\n      <span>&</span>\r\n      <img src="' +
((__t = (require('../../assets/images/logo2.png'))) == null ? '' : __t) +
'" alt="">\r\n    </a>\r\n  </div>\r\n  <div class="fixed-social">\r\n    <a href="#" target="_blank"><i class="iconfont icon-a-linkedin1"></i></a>\r\n    <a href="#" target="_blank"><i class="iconfont icon-facebook-fill"></i></a>\r\n    <a href="#" target="_blank"><i class="iconfont icon-youtube"></i></a>\r\n  </div>\r\n</header>';

}
return __p
}